import {
  FantazFailure,
  ResetPasswordOutput,
  VerifiableUserAttributeKey,
} from '@fantaz/shared/data-access/models';
import {
  createAction,
  createActionGroup,
  emptyProps,
  props,
} from '@ngrx/store';

export const resetPasswordRestoreInitialState = createAction(
  'Profile User Reset Password Restore Initial State',
);

export const resetPassword = createAction(
  'Profile User Reset Password',
  props<{ password: string; username: string; attributeKey: string }>(),
);

export const sendResetPasswordCode = createAction(
  'Profile User Send Reset Password Code',
);
export const resendResetPasswordCode = createAction(
  'Profile User Resend Reset Password Code',
);
export const sendResetPasswordCodeSuccess = createAction(
  'Profile User Send Reset Password Code Success',
  props<{ data: ResetPasswordOutput }>(),
);
export const sendResetPasswordCodeFailure = createAction(
  'Profile User Send Reset Password Code Failure',
  props<{ error: any }>(),
);

export const confirmResetPassword = createAction(
  'Profile User Confirm Reset Password',
  props<{ code: string }>(),
);
export const confirmResetPasswordSuccess = createAction(
  'Profile User Confirm Reset Password Success',
);
export const confirmResetPasswordFailure = createAction(
  'Profile User Confirm Reset Password Failure',
  props<{ error: any }>(),
);
